/**
 * Client-specific infrastructure notes
 *
 * These notes are displayed on encoder detail pages to document
 * tribal knowledge about how each client's infrastructure is set up.
 *
 * To add notes for a new client:
 * 1. Create a new file (e.g., acme.ts) with the client's notes
 * 2. Import and register it in CLIENT_INFRA_NOTES below
 */

// Types
export interface InfraNote {
  title: string;
  description?: string;
}

export interface ClientInfraNotes {
  clientName: string;
  protocol?: {
    actual: string;
    note: string;
  };
  portPattern?: string;
  configLocation?: {
    system: string;
    path: string;
    credentials: string;
    url?: string;
  };
  notes?: InfraNote[];
}

// Import client-specific notes
import { OREGON_CLIENT_ID, oregonNotes } from './oregon';
import { ARIZONA_CLIENT_ID, arizonaNotes } from './arizona';
import { KCIA_CLIENT_ID, kciaNotes } from './kcia';

/**
 * Registry of clientID -> infrastructure notes
 */
const CLIENT_INFRA_NOTES: Record<string, ClientInfraNotes> = {
  [OREGON_CLIENT_ID]: oregonNotes,
  [ARIZONA_CLIENT_ID]: arizonaNotes,
  [KCIA_CLIENT_ID]: kciaNotes,
};

/**
 * Get infrastructure notes for a client, if any exist
 */
export function getClientInfraNotes(clientID: string): ClientInfraNotes | null {
  return CLIENT_INFRA_NOTES[clientID] ?? null;
}
